<template>
  <div>
    <lk-form ref="form" :rules="formRules" :model="formObject" :label-width="140">
      <lk-row v-for="(array, idx) in config" :key="idx">
        <lk-col v-for="(item, index) in array" span="12" :key="index">
          <lk-form-item :label="item.title+':'" :prop="item.prop" :class="{'ivu-form-item-required':item.required}">
            <span v-if="item.type === 'span'">{{`${formObject[item.key]}`}}</span><span v-if="item.isShowOtherTxt" style="color:red;margin-left:20px;">{{item.isShowOtherTxt}}</span>
            <lk-input
              v-if="item.type === 'input'"
              v-model="formObject[item.key]"
              :style="item.style"
              :type="item.inputType || 'text'"
              :placeholder="item.placeholder || ''"
              :rows="item.rows || 2"
              :maxlength="item.maxlength || 200">
            </lk-input>
            <lk-input-number
              v-if="item.type === 'inputNumber'"
              :step="item.step"
              :max="item.max"
              :min="item.min"
              :style="item.style"
              :placeholder="item.placeholder"
              :precision="item.precision"
              @on-change="handleInpNumChange(item.key)"
              v-model="formObject[item.key]">
            </lk-input-number>
            <lk-select v-if="item.type === 'select'" v-model="formObject[item.key]">
              <lk-options v-for="ele in item.options" :key="ele.id" :value="ele.id">{{ele.name}}</lk-options>
            </lk-select>
            <timeStampDatePicker
              v-if="item.type === 'date'"
              v-model="formObject[item.key]"
              :type="item.dateType || 'date'"
              :style="item.style"
              :placeholder="item.placeholder"
              :options="item.options"
            >
            </timeStampDatePicker>
            <div v-if="item.type === 'inputSearch'">
              <InputSearch
                v-if="item.isShowInputSearch"
                style="width: 400px;display:inline-block;"
                v-model.trim="item.value"
                :placeHolder='item.placeholder'
                @selected='addGoods'
                @getData='handleInputChange'
                :data='item.goodsData'
                :columns='item.goodsColumns'
                :reset="false"
                >
              </InputSearch>
              <span v-if="!item.isShowInputSearch">{{item.value}}</span>
              <div style="width: 170%;display:flex;flex-wrap:wrap;background-color:rgba(243,250,254);margin-top:16px;">
                <div v-for="ele in item.showFields" style="width:33%;display:flex;">
                  <div class="symbolStyle" v-if="!ele.isCheck && ele.key === 'purchasePrice'">*</div>
                  <div style="width:30%;text-align:right;">{{ele.title}}</div>
                    <div v-if="!ele.isCheck && ele.key === 'purchasePrice'">
                        <NumberInput
                          :style="ele.style"
                          type='ifNeedCheckAllNumber'
                          :ifNeedCheckAllNumber='true'
                          :frontDecimal='5'
                          :precision ='2'
                          :min='0'
                          v-model='fieldData[ele.key]'
                          size='default'
                        ></NumberInput>
                    </div>
                    <div v-else>
                      {{fieldData[ele.key] === undefined ? '' : fieldData[ele.key]}}
                    </div>
                </div>
              </div>
            </div>
            <div v-if="item.type==='upload'">
              <Attachment
                :isCanEdit="item.isCanEdit"
                :uploadInfo='item.uploadInfo'
                @attachmentConfirm='attachmentConfirm'
              ></Attachment>
            </div>
          </lk-form-item>
        </lk-col>
      </lk-row>
    </lk-form>
  </div>
</template>

<script>
import InputSearch from '@/components/InputSearch.vue';
import Attachment from '../purchase/Attachment.vue';

export default {
  name: 'receiveableLimitAdd',
  components: {
    InputSearch,
    Attachment,
  },
  props: {
    formRules: {
      type: Object,
    },
    formObject: {
      type: Object,
    },
    config: {
      type: Array,
    },
    fieldData: {
      type: Object,
    },
  },
  data() {
    return {

    };
  },
  methods: {
    handleInputChange() {
      this.$emit('change');
    },
    addGoods(val) {
      this.$emit('add', val);
    },
    attachmentConfirm(val) {
    //   this.uploadInfo = val;
      this.$emit('attach', val);
    },
    handleInpNumChange(val) {
      this.$emit('inputNumChange', val);
    },
  },
};
</script>

<style lang="less" scoped>
  .symbolStyle {
    color:#ed4014;
    font-size: 16px;
    position: absolute;
    text-align: center;
    left: 56px;
    bottom: -1px;
  }
</style>
